<template>
  <div v-if="isGroupAccount">
    <div class="mb-auto w-100 form">
      <div class="row">
        <div class="col-4 input-group pb-2 mb-4 custom-file-upload">
          <label class="">
            {{ this.$t('services.persons-import.upload-file') }}
            <input @change="uploadFile" ref="file" type="file" name="price-file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
          </label>
          <span>{{ file.name }}</span>
        </div>
      </div>
      <br/>
      <div><small>{{ this.$t('services.persons-import.description') }}</small></div>
      <br/>

      <div class="row">
        <div class="col-5">
          <button v-if="!importInProcess && !unhandledPersons.length && !handledPersons.length" class="btn btn-sm btn-primary" @click="importPrices">
            {{ this.$t('services.persons-import.import') }}
          </button>
          <spinner-tile v-if="importInProcess"
                        class="center-block"
                        :loading="importInProcess"
                        :key="importInProcess"
          ></spinner-tile>
        </div>
      </div>
    </div>
    <div v-if="unhandledPersons.length || handledPersons.length">
      <br/>
      <a @click="showHandled = !showHandled">Success: {{ handledPersons.length }}</a>,
      <a @click="showUnhandled = !showUnhandled">Unhandled: {{ unhandledPersons.length }}</a>
      <ul v-if="showHandled" style="color: green">
        <li v-for="(title, index) in handledPersons" v-bind:key="index">
          {{ title }}
        </li>
      </ul>
      <ul v-if="showUnhandled" style="color: red">
        <li v-for="(title, index) in unhandledPersons" v-bind:key="index">
          {{ title }}
        </li>
      </ul>
      <br />
      <div><button class="btn btn-sm btn-primary" @click="reloadPage">Reload page</button></div>
    </div>
  </div>

  <div class="side-page-content search-page-search" v-else>
    Not allowed
  </div>
</template>

<script>
import Person from '@/services/hatsApi/Person'
import Button from '../form/Button.vue'

export default {
  components: {Button},
  props: {
    reservation: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      file: '',
      showHandled: false,
      showUnhandled: false,
      importInProcess: false,
      unhandledPersons: [],
      handledPersons: []
    }
  },
  async created () {
  },
  methods: {
    uploadFile () {
      this.file = this.$refs.file.files[0]
    },
    async reloadPage () {
      location.href = '/reservation/' + this.reservation.id
    },
    async importPrices () {
      this.importInProcess = true
      this.unhandledPersons = []
      this.handledPersons = []
      const formData = new FormData()
      formData.append('file', this.file)
      formData.append('reservationId', this.reservation.id)
      let response = await Person.importPersons(formData)
      this.importInProcess = false
      this.unhandledPersons = response.data.data.errorPersons
      this.handledPersons = response.data.data.successPersons
    }
  },
  computed: {
    isGroupAccount () {
      return this.$store.getters.account.name.includes('Groepsreizen')
    }
  }
}
</script>

<style lang="scss" scoped>
.custom-file-upload {
  display: flex;
  align-items: center;

  label {
    border: 1px solid #008cdd;
    display: inline-block;
    padding: 6px 12px;
    cursor: pointer;
    margin-bottom: 0;

    input[type="file"] {
      display: none;
    }
  }

  span {
    font-size: 12px;
    margin-left: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/reservation/PersonsImport.vue